import React from 'react';
import styled from 'styled-components';
import VStack from '../../../../VStack/VStack';

// Subcomponents
import { SiteKitUtilityAnchor } from './SiteKitUtilityAnchor/SiteKitUtilityAnchor';
import { SiteKitUtilityGroup } from './SiteKitUtilityGroup';
import { SiteKitUtilityGroupCollapsible } from './SiteKitUtilityGroupCollapsible';

// Fragments
const SiteKitUtilitiesWrapper = styled.div`
  align-items: end;
  display: grid;
  flex-grow: 1;
  overflow-y: auto;
`;

// Exports
interface SiteKitUtilitiesProps {
  children: React.ReactNode;
}
const SiteKitUtilities = ({ children }: SiteKitUtilitiesProps) => (
  <SiteKitUtilitiesWrapper>
    <VStack spacing="none">{children}</VStack>
  </SiteKitUtilitiesWrapper>
);
SiteKitUtilities.Anchor = SiteKitUtilityAnchor;
SiteKitUtilities.Group = SiteKitUtilityGroup;
SiteKitUtilities.GroupCollapsible = SiteKitUtilityGroupCollapsible;

SiteKitUtilities.displayName = 'SiteKit.Sidebar.Utilities';

export { SiteKitUtilities, SiteKitUtilitiesProps };
